import axios from 'axios';
import { Transaction } from '../types/models';
import { API_BASE } from './config';

export async function getTransactions(): Promise<Transaction[]> {
  try {
    const res = await axios.get<Transaction[]>(`${API_BASE}/transactions`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function getTransaction(id: number): Promise<Transaction> {
  try {
    const res = await axios.get<Transaction>(`${API_BASE}/transactions/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function createTransaction(transaction: Partial<Transaction>): Promise<Transaction> {
  try {
    const res = await axios.post<Transaction>(`${API_BASE}/transactions`, transaction);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function updateTransaction(id: number, transaction: Partial<Transaction>): Promise<Transaction> {
  try {
    const res = await axios.put<Transaction>(`${API_BASE}/transactions/${id}`, transaction);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function deleteTransaction(id: number): Promise<void> {
  try {
    await axios.delete(`${API_BASE}/transactions/${id}`);
  } catch (err) {
    throw err;
  }
}

export async function getTransactionsForAccount(address: string): Promise<Transaction[]> {
  try {
    const res = await axios.get<Transaction[]>(`${API_BASE}/accounts/${encodeURIComponent(address)}/transactions`);
    return res.data;
  } catch (err) {
    throw err;
  }
} 